import { message, Modal } from "antd";
import { innovitiPaymentCodes } from "../../../../constants/config";
import { v4 as uuidv4 } from "uuid";
import Axios from "axios";
import * as Sentry from "@sentry/react";
import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import axios from "axios";

import { processRazorpayQRPayment } from "./razorpayQRPaymentService";
import { upsertWorkflowEventStore } from "../../../../services";
import messages from "../../../../errors/messages.en-IN.json";

export const paymentProvider = (
  amountAdded,
  currentPaymentMethod,
  paymentMethod,
  value,
  cart,
  setCart,
  setLoader,
  setPaymentModal,
  completePayment,
  setSelectedPaymentMethod,
  setAmount,
  setPaytmQrCodeModalOpens,
  setQrCodeResponse,
  setShowCardPaymnteModal,
  setCardPaymnetError,
  setCardPaymnetStatus,
  setCardPaymnetStatusPLB,
  setLoading,
  setIsCardPaymentLoading,
  setLayoutType,
  setKioskUI,
  dispatchQRCodeEvent,
  closeQRCodeModal,
  wallet,
  cardPaymentDetails,
  setIntegratedPaymentStatus
) => {
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  if (currentPaymentMethod.paymentProvider === "INV" && currentPaymentMethod.integratedPayment === true) {
    processInnovitiEDCPayment(
      amountAdded,
      currentPaymentMethod,
      paymentMethod,
      value,
      tillData,
      tillLayout,
      cart,
      setCart,
      setLoader,
      setPaymentModal,
      completePayment,
      setSelectedPaymentMethod,
      setAmount,
      setLoading,
      wallet
    );
  } else if (currentPaymentMethod.paymentProvider === "PTM" && currentPaymentMethod.integratedPayment === true && !currentPaymentMethod.paymentProviderDetails) {
    processPaytmEDCPayment(
      amountAdded,
      currentPaymentMethod,
      paymentMethod,
      value,
      tillData,
      tillLayout,
      cart,
      setCart,
      setLoader,
      setPaymentModal,
      completePayment,
      setSelectedPaymentMethod,
      setAmount,
      setLoading,
      wallet
    );
  } else if (currentPaymentMethod.paymentProvider === "ADC" && currentPaymentMethod.integratedPayment === true) {
    processADCPayment(
      amountAdded,
      currentPaymentMethod,
      paymentMethod,
      value,
      tillData,
      tillLayout,
      cart,
      setCart,
      setLoader,
      setPaymentModal,
      completePayment,
      setSelectedPaymentMethod,
      setAmount,
      setShowCardPaymnteModal,
      setCardPaymnetError,
      setCardPaymnetStatus,
      setCardPaymnetStatusPLB,
      setLoading,
      setIsCardPaymentLoading,
      setLayoutType,
      setKioskUI,
      wallet,
      cardPaymentDetails,
      setIntegratedPaymentStatus
    );
  } else if (
    currentPaymentMethod.integratedPayment === true &&
    ((currentPaymentMethod.paymentProvider === "PLB" && currentPaymentMethod?.paymentProviderDetails?.integrationType === "API") ||
      (currentPaymentMethod.paymentProvider === "RP" && currentPaymentMethod?.paymentProviderDetails?.providerCode === "RPEDC") ||
      (currentPaymentMethod?.paymentProvider === "PTM" && currentPaymentMethod?.paymentProviderDetails?.providerCode === "PYTMEDC"))
  ) {
    processPLBPayment(
      amountAdded,
      currentPaymentMethod,
      paymentMethod,
      value,
      tillData,
      tillLayout,
      cart,
      setCart,
      setLoader,
      setPaymentModal,
      completePayment,
      setSelectedPaymentMethod,
      setAmount,
      setShowCardPaymnteModal,
      setCardPaymnetError,
      setCardPaymnetStatus,
      setCardPaymnetStatusPLB,
      setLoading,
      setIsCardPaymentLoading,
      setLayoutType,
      setKioskUI,
      wallet,
      cardPaymentDetails,
      setIntegratedPaymentStatus
    );
  } else if (
    currentPaymentMethod.paymentProvider === "RP" &&
    currentPaymentMethod.integratedPayment === true &&
    currentPaymentMethod?.paymentProviderDetails?.providerCode === "RPGTY"
  ) {
    processRazorpayQRPayment(
      amountAdded,
      currentPaymentMethod,
      paymentMethod,
      value,
      tillData,
      tillLayout,
      cart,
      setCart,
      setLoader,
      setPaymentModal,
      completePayment,
      setSelectedPaymentMethod,
      setAmount,
      setLoading,
      dispatchQRCodeEvent,
      closeQRCodeModal,
      setLayoutType,
      setKioskUI,
      wallet,
      cardPaymentDetails,
      setIntegratedPaymentStatus
    );
  } else if (currentPaymentMethod.integratedPayment === false && currentPaymentMethod.paymentProvider === "PTM") {
    processQrPaytmPayment(
      amountAdded,
      currentPaymentMethod,
      paymentMethod,
      value,
      tillData,
      tillLayout,
      cart,
      setCart,
      setLoader,
      setPaymentModal,
      completePayment,
      setSelectedPaymentMethod,
      setAmount,
      setPaytmQrCodeModalOpens,
      setQrCodeResponse,
      setLoading,
      wallet
    );
  } else if (currentPaymentMethod.integratedPayment === true) {
    message.error(`${messages.errors.payments.invalid_payment_provider}`);
  }
};

const processInnovitiEDCPayment = (
  amountAdded,
  currentPaymentMethod,
  paymentMethod,
  value,
  tillData,
  tillLayout,
  cart,
  setCart,
  setLoader,
  setPaymentModal,
  completePayment,
  setSelectedPaymentMethod,
  setAmount,
  setLoading
) => {
  const edcUrl = process.env.REACT_APP_edcUrl;
  if (amountAdded >= 1) {
    const requestCode = innovitiPaymentCodes[currentPaymentMethod.name];
    const trxId = uuidv4().replace(/-/g, "").toUpperCase();
    const cashierId = tillData.tillAccess.csUserId;
    const customerMobileNo = cart.customer.mobileNo;
    setLoader(true);
    setPaymentModal(false);
    console.info(`Innoviti Request URL: ${edcUrl}?value=0,${requestCode},${trxId}!${cashierId}!${customerMobileNo}!,${amountAdded.toString().split(".").join("")}`);
    Axios.get(`${edcUrl}?value=0,${requestCode},${trxId}!${cashierId}!${customerMobileNo}!,${amountAdded.toString().split(".").join("")}`)
      .then((response) => {
        const result = response.data;
        const { ResponseCode, ResponseMessage } = result;
        if (ResponseCode === "00") {
          setLoader(false);
          if (tillLayout === 2) {
            setPaymentModal(true);
          }
          message.success("Payment Success");
          completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, 0);
        } else {
          setLoader(false);
          if (tillLayout === 2) {
            setPaymentModal(true);
          }
          message.error(`${messages.info.payment_failed}: ${ResponseMessage}`);
        }
      })
      .catch((error) => {
        console.error(`${messages.info.payment_failed}:`, error);
        setLoader(false);
        if (tillLayout === 2) {
          setPaymentModal(true);
        }
        message.error(`${messages.info.payment_failed}: ${messages.errors.gift_card.timeout}`);
      });
  } else {
    console.warn("Minimum amount not satisfied");
  }
};

const cancelPaytmVerifyPaymentRequest = (options) => {
  options.data.type = 6;
  Axios(options);
};

const paytmVerifyEDCPaymentStatus = (options) => {
  return new Promise(async function (verify) {
    Modal.confirm({
      title: "Payment request initiated",
      content: "Please verify",
      okText: "Verify",
      onOk: () => {
        verify("retry");
      },
      onCancel: () => {
        cancelPaytmVerifyPaymentRequest(options);
        verify("cancel");
      },
    });
  });
};

const chekPaytmEDCPaymentStatus = (options) => {
  return new Promise(async function (process, reject) {
    let retries = true;
    while (retries) {
      try {
        const response = await Axios(options);
        const result = response.data;
        // const result = { "result": 0, "resultCode": "101", "resultMessage": "Transaction already present", "transactionID": null, "authorizationID": null, "request": null, "properties": null };
        if (result.result?.toString() === "200") {
          retries = false;
          process(true);
        } else if (result.result?.toString() === "202" || result.result?.toString() === "203") {
          message.info(result.resultMessage);
          const retryStatus = await paytmVerifyEDCPaymentStatus(options);
          if (retryStatus === "retry") {
            retries = true;
          } else {
            message.error(`${messages.errors.payments.payment_cancelled}`);
            retries = false;
            process(false);
          }
        } else {
          message.error(result.resultMessage);
          retries = false;
          process(false);
        }
      } catch (err) {
        retries = false;
        reject(err);
      }
    }
  });
};

const processPaytmEDCPayment = (
  amountAdded,
  currentPaymentMethod,
  paymentMethod,
  value,
  tillData,
  tillLayout,
  cart,
  setCart,
  setLoader,
  setPaymentModal,
  completePayment,
  setSelectedPaymentMethod,
  setAmount,
  setLoading,
  wallet
) => {
  const trxId = uuidv4().replace(/-/g, "").toUpperCase();
  setLoader(true);
  if (tillLayout === 2) {
    setPaymentModal(true);
  }
  const requestData = {
    url: `${tillData.tillAccess.cwrTill.hardwareController.imageUrl}payment`,
    method: "POST",
    data: {
      type: 0,
      transactionID: trxId,
      terminalID: "111",
      currency: "INR",
      amount: amountAdded,
      properties: {},
      paymentProvider: "Paytm",
    },
    headers: {
      "Content-Type": "Application/json",
    },
  };

  chekPaytmEDCPaymentStatus(requestData)
    .then((response) => {
      if (response) {
        setLoader(false);
        if (tillLayout === 2) {
          setPaymentModal(true);
        }
        message.success("Payment Success");
        completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, 0);
      } else {
        setLoader(false);
        if (tillLayout === 2) {
          setPaymentModal(true);
        }
      }
    })
    .catch((error) => {
      console.error(`${messages.info.payment_failed}:`, error);
      setLoader(false);
      if (tillLayout === 2) {
        setPaymentModal(true);
      }
      message.error(`${messages.info.payment_failed}: ${messages.errors.gift_card.timeout}`);
    });
};

const processQrPaytmPayment = async (amountAdded, currentPaymentMethod, paymentMethod, value, tillData, cart, setPaytmQrCodeModalOpens, setQrCodeResponse) => {
  let setAuthTokens;
  const authHeaders = await getOAuthHeaders();
  if (authHeaders && authHeaders.access_token) {
    setAuthTokens = authHeaders.access_token;
  }
  setPaytmQrCodeModalOpens(true);
  let hostUrl = tillData.tillAccess.cwrTill.hardwareController.imageUrl;
  let paytmUrl = `${hostUrl}paytm/generateQRCode`;
  const getQRCodeValues = {
    midId: "Excelo34085435005810",
    orderId: `${cart.sOrderID}`,
    amount: amountAdded,
    businessType: "UPI_QR_CODE",
    posId: `${tillData.tillAccess.cwrTill.cwrTillID}`,
    merchantKey: "qQUxrwRx@qE6zTxt",
    payTMQRUrl: "https://securegw-stage.paytm.in/paymentservices/qr/create",
    clientId: "C11",
    version: "v1",
  };
  await Axios({
    url: paytmUrl,
    method: "POST",
    data: getQRCodeValues,
    headers: {
      "Content-Type": "application/json",
      Authorization: `${setAuthTokens}`,
    },
  }).then((response) => {
    setQrCodeResponse(response.data);
  });
};

const processADCPayment = async (
  amountAdded,
  currentPaymentMethod,
  paymentMethod,
  value,
  tillData,
  tillLayout,
  cart,
  setCart,
  setLoader,
  setPaymentModal,
  completePayment,
  setSelectedPaymentMethod,
  setAmount,
  setShowCardPaymnteModal,
  setCardPaymnetError,
  setCardPaymnetStatus,
  setCardPaymnetStatusPLB,
  setLoading,
  setIsCardPaymentLoading,
  setLayoutType,
  setKioskUI,
  wallet,
  cardPaymentDetails,
  setIntegratedPaymentStatus
) => {
  let setAuthTokens;
  const controller = new AbortController();
  const signal = controller.signal;
  let timeoutId = setTimeout(() => {
    controller.abort();
  }, 90000);
  setCardPaymnetStatus({
    paymentStatus: true,
    message: "Payment is processing, Please wait",
    paymentMode: paymentMethod?.name,
  });
  try {
    // Get OAuth headers
    const authHeaders = await getOAuthHeaders();
    setAuthTokens = authHeaders?.access_token ?? null; // Default to null if access_token is not available

    if (!setAuthTokens) {
      throw new Error("Authorization token is missing");
    }

    // Prepare ADC values
    const adcUrl = `${tillData?.tillAccess?.cwrTill?.pHWController?.imageUrl ?? ""}payment`;
    const tillValue = JSON.parse(localStorage.getItem("tillValue")) || {};
    const nameTill = tillValue?.name ?? "UnknownTill";
    const adcValues = {
      type: 0,
      terminal: nameTill,
      transaction: `${tillData?.tillAccess?.cwrTill?.prefix ?? ""}${cart?.documentno ?? ""}`,
      ReceiptNo: `${tillData?.tillAccess?.cwrTill?.prefix ?? ""}${cart?.documentno ?? ""}`,
      amount: amountAdded - (cart?.paid ?? 0),
      currency: tillData?.tillAccess?.csBunit?.currencies[0]?.isoCode ?? "USD",
      properties: {},
      test: true,
    };

    // Make POST request to ADC URL
    const response = await Axios.post(adcUrl, adcValues, {
      headers: {
        "Content-Type": "application/xml; charset=UTF-8",
        Accept: "application/xml",
      },
    });
    // Handle ADC response

    if (response?.data?.resultCode === "00" || response?.data?.resultCode === "0000") {
      setShowCardPaymnteModal(false);
      cart.cardPaymentData.payload = [adcValues];
      cart.cardPaymentData.response = [response.data];
      paymentMethod.authorization = response?.data?.authorization ?? "";
      completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, 0);
    } else {
      const errorMessage = response?.data?.resultMessage ?? "Unknown port error";
      setCardPaymnetError(true);
      setCardPaymnetStatus({
        paymentStatus: false,
        message: response.data.resultMessage || "Please check the hardware controller is not responding",
        paymentMode: paymentMethod?.name,
      });

      // Log the error to the server
      const serverUrl = process.env.REACT_APP_serverUrl ?? "";
      const cleanToken = authHeaders?.access_token ?? "";
      const additionalData = {
        tillValue: JSON.parse(localStorage.getItem("tillValue")) || {},
        adcUrl,
        adcValues,
      };
      const exceptionData = {
        CardPaymentError: {
          response: response?.data ?? {},
          requestData: response?.data?.request ?? {},
          ...additionalData,
        },
      };
      const uniqueId = uuidv4().replace(/-/g, "").toUpperCase();
      try {
        const workFlowResponse = await upsertWorkflowEventStore(uniqueId, "POS", "CE", exceptionData);
        console.log(workFlowResponse?.data?.data?.upsertWorkflowEventStore?.message ?? "Workflow event store error");
      } catch (err) {
        console.log(err);
      }
      Sentry.captureException(new Error("Card payment failed"), {
        extra: exceptionData,
      });
    }
  } catch (error) {
    clearTimeout(timeoutId);
    const errorMessage = error?.response?.data?.message || error?.message || "Please check the hardware controller is not responding";
    setCardPaymnetStatus({
      paymentStatus: false,
      message: errorMessage,
      paymentMode: paymentMethod?.name,
    });
    Sentry.captureException(error);
    setCardPaymnetError(true);
    console.error("Error occurred during card payment:", errorMessage);
  }
};

let cancelPolling = false;
const processPLBPayment = async (
  amountAdded,
  currentPaymentMethod,
  paymentMethod,
  value,
  tillData,
  tillLayout,
  cart,
  setCart,
  setLoader,
  setPaymentModal,
  completePayment,
  setSelectedPaymentMethod,
  setAmount,
  setShowCardPaymnteModal,
  setCardPaymnetError,
  setCardPaymnetStatus,
  setCardPaymnetStatusPLB,
  setLoading,
  setIsCardPaymentLoading,
  setLayoutType,
  setKioskUI,
  wallet,
  cardPaymentDetails,
  setIntegratedPaymentStatus
) => {
  cancelPolling = false;
  const API_URL = `${process.env.REACT_APP_API_URL}api/paymentGateway`;
  const cartObj = JSON.parse(localStorage.getItem("cartObj"));
  const userData = JSON.parse(localStorage.getItem("userData"));

  if (!cartObj || !userData) {
    console.error("Cart or User data missing from local storage.");
    return;
  }
  // setLoading(true);
  setShowCardPaymnteModal(true);
  setIsCardPaymentLoading(true);
  setCardPaymnetError(false);
  setCardPaymnetStatus({
    paymentStatus: true,
    message: "Payment is processing, Please wait",
    paymentMode: paymentMethod?.name,
  });
  try {
    const paymentProviderDetails = paymentMethod.paymentProviderDetails;
    const saleTypeId = paymentMethod.saleTypeId;
    const saleTypeName = paymentMethod.saleTypeName;
    const requestBody = {
      PaymentProviderDetails: paymentProviderDetails,
      SaleTypeId: saleTypeId,
      SaleTypeName: saleTypeName,
      TillId: JSON.parse(localStorage.getItem("tillValue"))?.name,
      DocumentNo: cart?.documentno,
      meta: [
        {
          key: "mobileNo",
          value: cart?.customer?.mobileNo || "",
        },
      ],
    };

    const allPayments = [...(cart.paymentData || []), ...(cart.payments || [])];
    const existingSamePaymentMethod = allPayments?.filter((p) => p.name === paymentMethod.name);
    const suffix = existingSamePaymentMethod && existingSamePaymentMethod.length > 0 ? `-${existingSamePaymentMethod.length}` : "";
    const transactionNumber = `${cartObj.documentno}-${paymentMethod.name}${suffix}`;
    const response = await axios.post(
      `${API_URL}?apiType=uploadTransaction&TransactionNumber=${transactionNumber}&SequenceNumber=1&AllowedPaymentMode=1&Amount=${value}&UserID=${userData.user_id}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const { PlutusTransactionReferenceID } = response.data;
    const originalRequest = response.data?.OriginalResponse?.OriginalRequest;
    const amount = cartObj.total;

    if (!PlutusTransactionReferenceID) {
      console.error("Transaction Reference ID missing in response.");
      setLoading(false);
      setIsCardPaymentLoading(false);
      return;
    }

    localStorage.setItem("transactionId", PlutusTransactionReferenceID);
    localStorage.setItem("transactionAmount", amount);

    // Step 2: Poll for transaction status
    await pollTransactionStatus(
      PlutusTransactionReferenceID,
      cart,
      paymentMethod,
      value,
      setCart,
      setAmount,
      setSelectedPaymentMethod,
      completePayment,
      setShowCardPaymnteModal,
      setCardPaymnetError,
      setCardPaymnetStatus,
      setCardPaymnetStatusPLB,
      setLoading,
      setIsCardPaymentLoading,
      setLayoutType,
      setKioskUI,
      wallet,
      cardPaymentDetails,
      setIntegratedPaymentStatus,
      originalRequest
    );
    // }
  } catch (error) {
    setCardPaymnetError(true);
    setCardPaymnetStatus({
      paymentStatus: false,
      message: "Payment failed. Please try again.",
      paymentMode: paymentMethod?.name,
    });
    setLoading(false);
    setIsCardPaymentLoading(false);
  }
};

const resetTimeoutRef = { current: null };

const pollTransactionStatus = async (
  PlutusTransactionReferenceID,
  cart,
  paymentMethod,
  value,
  setCart,
  setAmount,
  setSelectedPaymentMethod,
  completePayment,
  setShowCardPaymnteModal,
  setCardPaymnetError,
  setCardPaymnetStatus,
  setCardPaymnetStatusPLB,
  setLoading,
  setIsCardPaymentLoading,
  setLayoutType,
  setKioskUI,
  wallet,
  cardPaymentDetails,
  setIntegratedPaymentStatus,
  originalRequest,
  attempt = 1,
  maxAttempts = 12,
  interval = 10000
) => {
  if (cancelPolling) return;
  const API_URL = `${process.env.REACT_APP_API_URL}api/paymentGateway`;
  if (attempt > maxAttempts) {
    setShowCardPaymnteModal(false);
    setLoading(false);
    setIsCardPaymentLoading(false);
    setLayoutType(9);
    localStorage.setItem("layoutType", 9);

    // Dispatch a custom event to notify other parts of the UI
    const layoutEvent = new CustomEvent("customStorageChange", {
      detail: { key: "layoutType", newValue: 9 },
    });
    window.dispatchEvent(layoutEvent);

    setKioskUI(5);
    localStorage.setItem("kioskUI", 5);
    const kioskEvent = new CustomEvent("customStorageChange", {
      detail: { key: "kioskUI", newValue: 5 },
    });
    window.dispatchEvent(kioskEvent);
    setCardPaymnetStatusPLB(true);
    return;
  }
  const paymentProviderDetails = paymentMethod.paymentProviderDetails;
  const saleTypeId = paymentMethod.saleTypeId;
  const saleTypeName = paymentMethod.saleTypeName;
  const details = {
    PaymentProviderDetails: JSON.stringify(paymentProviderDetails),
    SaleTypeId: saleTypeId,
    SaleTypeName: saleTypeName,
    TillId: JSON.parse(localStorage.getItem("tillValue"))?.name,
    DocumentNo: cart?.documentno,
  };
  let originalRequestStr = JSON.stringify(originalRequest);
  try {
    const queryParams = new URLSearchParams(details).toString(); // Convert object to URL query string
    const statusResponse = await axios.get(`${API_URL}?apiType=checkStatus&transaction_id=${PlutusTransactionReferenceID}&originalRequest=${originalRequestStr}&${queryParams}`, {
      headers: { "Content-Type": "application/json" },
    });
    const { ResponseMessage, TransactionData } = statusResponse.data;
    if (
      ResponseMessage?.trim().toUpperCase() === "TXN APPROVED" ||
      ResponseMessage?.trim().toUpperCase() === "APPROVED" ||
      ResponseMessage?.trim().toUpperCase() === "ACCEPTED_SUCCESS"
    ) {
      setLoading(false);
      setIsCardPaymentLoading(false);
      cancelPolling = true;
      setCardPaymnetError(false);
      setCardPaymnetStatus({
        paymentStatus: true,
        message: "Payment Success",
        paymentMode: paymentMethod?.name,
      });
      const tillData = JSON.parse(localStorage.getItem("tillData"));
      const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
      completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, 0, setLayoutType, setKioskUI, wallet, precision);
      setTimeout(() => {
        setShowCardPaymnteModal(false);
      }, 3000);
      return;
    } else if (
      ResponseMessage?.trim().toUpperCase() === "TRANSACTION FAILED" ||
      ResponseMessage?.trim().toUpperCase() === "INVALID PLUTUS TXN REF ID" ||
      ResponseMessage?.trim().toUpperCase() === "UPI Transaction Failed".toLocaleUpperCase()
    ) {
      setLoading(false);
      setIsCardPaymentLoading(false);
      cancelPolling = true;
      setCardPaymnetError(true);
      setCardPaymnetStatus({
        paymentStatus: false,
        message: "Transaction failed or could not be verified.",
        paymentMode: paymentMethod?.name,
      });

      return;
    }

    // If not approved, retry after delay
    setTimeout(() => {
      pollTransactionStatus(
        PlutusTransactionReferenceID,
        cart,
        paymentMethod,
        value,
        setCart,
        setAmount,
        setSelectedPaymentMethod,
        completePayment,
        setShowCardPaymnteModal,
        setCardPaymnetError,
        setCardPaymnetStatus,
        setCardPaymnetStatusPLB,
        setLoading,
        setIsCardPaymentLoading,
        setLayoutType,
        setKioskUI,
        wallet,
        cardPaymentDetails,
        setIntegratedPaymentStatus,
        originalRequest,
        attempt + 1,
        maxAttempts,
        interval
      );
    }, interval);
  } catch (error) {
    console.error("Error checking transaction status:", error);
    setCardPaymnetError(true);
    setCardPaymnetStatus({
      paymentStatus: false,
      message: "Error checking payment status. Retrying...",
      paymentMode: paymentMethod?.name,
    });
    // Retry on failure
    setTimeout(() => {
      pollTransactionStatus(
        PlutusTransactionReferenceID,
        cart,
        paymentMethod,
        value,
        setCart,
        setAmount,
        setSelectedPaymentMethod,
        completePayment,
        setShowCardPaymnteModal,
        setCardPaymnetError,
        setCardPaymnetStatus,
        setCardPaymnetStatusPLB,
        setLoading,
        setIsCardPaymentLoading,
        setLayoutType,
        setKioskUI,
        wallet,
        cardPaymentDetails,
        setIntegratedPaymentStatus,
        originalRequest,
        attempt + 1,
        maxAttempts,
        interval
      );
    }, interval);
  }
};
